/**
 * Step 7: RG
 * Coleta o número do RG do usuário
 */

import React, { useState } from 'react';
import { StepContainer, FormFieldGroup, StepNavigation } from '../components';
import { StepProps, useFormContext } from '../context';
import { useFormValidation } from '../hooks';
import { validateRG } from '../validators';

const Step7_RG: React.FC<StepProps> = ({ onNext, onPrevious, data, isLoading }) => {
  const { updateFields } = useFormContext();
  const [localData, setLocalData] = useState({ rgDocument: data.rgDocument || '' });
  const [errors, setErrors] = useState<Record<string, string>>({});

  const handleChange = (value: string) => {
    // Remove tudo que não é número
    const cleaned = value.replace(/\D/g, '');
    setLocalData({ rgDocument: cleaned });
    setErrors({});
  };

  const handleNext = () => {
    const validation = validateRG(localData.rgDocument);
    
    if (!validation.valid) {
      setErrors({ rgDocument: validation.error || 'RG inválido' });
      return;
    }

    updateFields(localData);
    onNext(localData);
  };

  return (
    <StepContainer
      title="Qual seu RG?"
      description="Digite apenas os números"
    >
      <FormFieldGroup
        label="RG"
        error={errors.rgDocument}
        required
      >
        <input
          type="text"
          placeholder="123456789"
          value={localData.rgDocument}
          onChange={(e) => handleChange(e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-[#5c5c5c]"
        />
      </FormFieldGroup>

      <StepNavigation
        onNext={handleNext}
        onPrevious={onPrevious}
        isLoading={isLoading}
        showPrevious={true}
      />
    </StepContainer>
  );
};

export default Step7_RG;
